import React, { useRef, useState } from "react";
import styled from "styled-components";
import IconButtonNew from "../../../global/buttonsLinks/IconButtonNew";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import Popper from "../../../global/popper/Popper";
import { backDrop, openButton } from "../../../utils/z-index";

export const Container = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  position: relative;
  z-index: ${openButton};
`;

export const FlapOutContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grays4};
  border-radius: 8px;
  max-height: 70vh;
  overflow: scroll;
  margin: 10px;

  @media (min-width: 600px) {
    width: 460px;
  }

  @media (min-width: 1280px) {
    max-height: 400px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &::-moz-scrollbar {
    display: none;
  }

  ms-overflow-style: none;
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
`;

const StyledPopper = styled(Popper)`
  z-index: ${backDrop} !important;
`;

const Flap = (props: {
  icon: IconDefinition;
  children: JSX.Element[] | JSX.Element | null;
  onClose?(): void;
}): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  return (
    <Container ref={ref}>
      <IconButtonNew
        focused={open}
        onClick={() => {
          setOpen(!open);
        }}
        icon={props.icon}
      />
      <StyledPopper anchorEl={ref.current} open={open}>
        <ClickAwayListener
          onClickAway={() => {
            setOpen(false);
            props.onClose?.();
          }}
        >
          <FlapOutContainer>{props.children}</FlapOutContainer>
        </ClickAwayListener>
      </StyledPopper>
    </Container>
  );
};

export default Flap;
